// docs.sentry.io/platforms/javascript/configuration/filtering/ - documentation

export const ignoreList = [
  `Converting circular structure to JSON
  --> starting at object with constructor 'HTMLAnchorElement'
  |     property '__reactFiber$o2eqdf5tol' -> object with constructor 'zu'
  --- property 'stateNode' closes the circle`,
];
